
import { app } from "@/config/firebase";
import { getFirestore } from "firebase/firestore";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import _ from 'lodash';

// Initialize Firebase
const db = getFirestore(app);

async function getInquiries(filter = {}) {
    try {
        let inquiries = {};

        const conditions = [];
        if (filter.status) {
            conditions.push(where("status", "==", filter.status));
        }
        conditions.push(orderBy("dateCreated", "desc"));

        const dbRef = query(collection(db, "inquiries"), ...conditions);
        const querySnapshot = await getDocs(dbRef);

        querySnapshot.forEach((doc) => {
            inquiries[doc.id] = doc.data();
        });

        return inquiries;
    } catch (error) {
        throw error;
    }
}

export default {
    getInquiries,
}